import React from "react";
import Banner from "../components/Home/Banner.js";
import Mechanism from "../components/Home/Mechanism.js";
import Verification from "components/Home/Verification.js";
import { Section, Steps, ProofBand, CTA } from "../components/Page/Page.js";
import Audiences from "../components/Page/Audiences.js";
import Newsletter from "../components/Page/Newsletter.js";

export default function HomeScreen() {
  return (
    <>
      <Banner />
      <Section title="How can we help you?"><Audiences /></Section>
      <Mechanism />
      <ProofBand />
      <Section title="How it works"><Steps /></Section>
      <Verification />
      <Newsletter />
      <CTA />
    </>
  );
}
